import { isEmptyObject, isEmptySimpleObject, isTagNameInArrayMode, merge, } from './util.js';
/**
 *
 * @param node
 * @param options
 * @param parentTagName
 * @returns
 */
export function traversableToJSON(node, options, parentTagName) {
    const { arrayMode, tagNameProcessor, attributeNameProcessor, textNodeName } = options;
    const result = {};
    // when no child node or attr is present
    if ((!node.children || isEmptyObject(node.children)) &&
        (!node.attributes || isEmptySimpleObject(node.attributes))) {
        return node.value;
    }
    // otherwise create a textnode if node has some text
    if (node.bytes.length > 0) {
        const asArray = isTagNameInArrayMode(node.tagName, arrayMode, parentTagName);
        result[textNodeName] = asArray ? [node.value] : node.value;
    }
    if (node.attributes && !isEmptySimpleObject(node.attributes)) {
        let attributes = options.parseAttributesString ? {} : node.attributes;
        if (attributeNameProcessor) {
            // need to rename the attributes
            const renamedAttributes = {};
            for (const attributeName in node.attributes) {
                const newAttributeName = attributeNameProcessor(attributeName);
                renamedAttributes[newAttributeName] = node.attributes[attributeName];
            }
            attributes = renamedAttributes;
        }
        if (options.attributesNodeName) {
            const encapsulatedAttributes = {
                [options.attributesNodeName]: attributes,
            };
            attributes = encapsulatedAttributes;
        }
        merge(result, attributes, arrayMode);
    }
    for (const tagName in node.children) {
        const nodes = node.children[tagName];
        const newTagName = tagNameProcessor
            ? tagNameProcessor(tagName, nodes)
            : tagName;
        if (nodes?.length > 1) {
            result[tagName] = [];
            for (const child of nodes) {
                result[newTagName].push(traversableToJSON(child, options, tagName));
            }
        }
        else {
            const subResult = traversableToJSON(nodes[0], options, tagName);
            const asArray = (arrayMode === true && typeof subResult === 'object') ||
                isTagNameInArrayMode(tagName, arrayMode, parentTagName);
            result[newTagName] = asArray ? [subResult] : subResult;
        }
    }
    return result;
}
//# sourceMappingURL=traversableToJSON.js.map